module.exports = __webpack_public_path__ + "img/gb9115_10.prt.3d92fd1a.jpg";